import { getDateSectionLabel } from '@griply/utils';
import Typography from '@mui/material/Typography';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useToday } from 'shared/contexts/today';
import { Timestamp } from 'shared/types/timestamp';
import { useTheme } from 'styled-components';

import * as Styled from './list-section-date-header.style';

export type ListSectionDateHeaderProps = {
  date: Timestamp;
};

export const ListSectionDateHeader: React.FC<ListSectionDateHeaderProps> =
  React.memo(({ date }) => {
    const { t } = useTranslation();
    const today = useToday();
    const theme = useTheme();

    const label = useMemo(
      () => getDateSectionLabel(date, today, t),
      [date, today, t],
    );

    return (
      <Styled.Container>
        <Typography variant="h6" component="span">
          {label.primary}
        </Typography>

        <Typography
          variant="h6"
          component="span"
          color={theme.palette.text.secondary}
        >
          {label.secondary}
        </Typography>
      </Styled.Container>
    );
  });
